var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.7083C10.5278 10.7083 10.9722 10.5278 11.3333 10.1666C11.6944 9.80554 11.875 9.36109 11.875 8.83331C11.875 8.30554 11.6944 7.86109 11.3333 7.49998C10.9722 7.13887 10.5278 6.95831 10 6.95831C9.47222 6.95831 9.02778 7.13887 8.66667 7.49998C8.30556 7.86109 8.125 8.30554 8.125 8.83331C8.125 9.36109 8.30556 9.80554 8.66667 10.1666C9.02778 10.5278 9.47222 10.7083 10 10.7083ZM10 19.5416C7.54167 17.5 5.69792 15.6458 4.46875 13.9791C3.23958 12.3125 2.625 10.625 2.625 8.91665C2.625 6.64276 3.36632 4.83123 4.84896 3.48206C6.33174 2.1329 8.04875 1.45831 10 1.45831C11.9513 1.45831 13.6683 2.1329 15.151 3.48206C16.6337 4.83123 17.375 6.64276 17.375 8.91665C17.375 10.625 16.7604 12.3125 15.5312 13.9791C14.3021 15.6458 12.4583 17.5 10 19.5416Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRed);
export default __webpack_public_path__ + "static/media/location-red.1b5c7cdd053dc90eb98ae939973d7fa6.svg";
export { ForwardRef as ReactComponent };